import type { ValidationResult } from 'joi';
import { cloneDeep } from 'lodash';
import moment from 'moment-timezone';

import { SerializableObject } from '../../../generic/serialization/serializable-object';
import { SerializableObjectSchema } from '../../../generic/serialization/serializable-object-schema';

import { RedisLockConstructor } from './redis-lock-constructor';
import { RedisLockSchema } from './redis-lock-schema';

export class RedisLock extends SerializableObject {
  /////////////////////////////////////////////////////////////////////////////
  // Variables
  /////////////////////////////////////////////////////////////////////////////

  protected token!: string;

  protected acquiredBy!: string;

  protected acquiredAt!: moment.Moment;

  protected expiresAt!: moment.Moment;

  protected value?: string;

  /////////////////////////////////////////////////////////////////////////////
  // Constructor
  /////////////////////////////////////////////////////////////////////////////

  constructor(parameters: RedisLockConstructor) {
    super(parameters);
  }

  /////////////////////////////////////////////////////////////////////////////
  // Deserialize
  /////////////////////////////////////////////////////////////////////////////

  /**
   * This static function is private, and meant to be called only by
   * SerializableObject, and subclasses
   *
   * @param validationResult
   */
  protected static _deserialize(validationResult: ValidationResult): RedisLock {
    return new RedisLock(super._deserialize(validationResult));
  }

  /////////////////////////////////////////////////////////////////////////////
  // Serialize
  /////////////////////////////////////////////////////////////////////////////

  public serialize() {
    return super.serialize(RedisLock.getSchema(), 'rtdb');
  }

  /////////////////////////////////////////////////////////////////////////////
  // Schema
  /////////////////////////////////////////////////////////////////////////////

  public static getSchema(): SerializableObjectSchema {
    return new RedisLockSchema();
  }

  /////////////////////////////////////////////////////////////////////////////
  // Getters
  /////////////////////////////////////////////////////////////////////////////

  public getToken(): string {
    return this.token;
  }

  public getAcquiredBy(): string {
    return this.acquiredBy;
  }

  public getAcquiredAt(): moment.Moment {
    return cloneDeep(this.acquiredAt);
  }

  public getExpiresAt(): moment.Moment {
    return cloneDeep(this.expiresAt);
  }

  public getValue() {
    return cloneDeep(this.value);
  }
}
